/* eslint-disable import/prefer-default-export */
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { i18n } from "~/i18n";
import { openGlobalModal } from "../reducers/general/actions";
import { businessInternalLogin, getBusinessProfile, businessInternalSetProfile } from "./api";
import store from "../reducers/store";
import link from "../static/text/link";
import { closeLogoutModal, openLogoutModal } from "../reducers/userState/actions";

export const isMobile = (theme) => useMediaQuery(theme.breakpoints.down("sm"));
export const isDesktop = (theme) => useMediaQuery(theme.breakpoints.up("md"));

const appPackageName = process.env.APP_PACKAGE_NAME;

export const languageParser = (ctx) => {
  if (ctx && ctx.req) {
    const language = ctx.req.lng || ctx.req.language || ctx.req.locale;
    if (typeof language === "string" && language.length > 0) {
      return language.split("-")[0].toLowerCase();
    }

    const rawUrl = ctx.req.originalUrl || ctx.req.url || "";
    const cleanPath = `${rawUrl}`.split("?")[0].split("#")[0];
    const pathLanguage = cleanPath.match(/^\/(id)(\/|$)/);
    if (pathLanguage) {
      return pathLanguage[1];
    }
  }
  return "en";
};

export const responsiveSource = (theme, largeSource, smallSource = "") => {
  if (smallSource) {
    if (isMobile(theme)) {
      return smallSource;
    }
  }
  return largeSource;
};

export const checkIsWebView = (ctx) => {
  const xRequestedWith = ctx.req.headers["x-requested-with"] ? ctx.req.headers["x-requested-with"] : "";
  if (xRequestedWith.includes(appPackageName)) {
    return true;
  }
  return false;
};

export const nameTruncate = (text) => {
  if (text.length >= 17) {
    return `${text.slice(0, 13)}...`;
  }
  return text;
};

export const langaugeChanger = async (lang) => {
  const urlLang = i18n.language;
  if (lang !== urlLang) {
    await i18n.changeLanguage(lang);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

export const rupiahFormatter = (number) => {
  let separator = "";
  const numberString = number.toString().replace(/[^,\d]/g, "").toString();
  const split = numberString.split(",");
  const sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  const ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
  return rupiah ? "Rp. " + rupiah : "";
};

export const showLogoutModal = (typeUser = null, title = null, subTitle = null) => {
  const modalValue = { typeUser, title, subTitle };
  store.dispatch(openLogoutModal(modalValue));
};

export const hideLogoutModal = () => {
  store.dispatch(closeLogoutModal());
};

export const showErrorAlert = (title = "", subtitle = "", onClose = () => { }, closeValue, widthType = null) => {
  const modalValue = {
    title,
    subtitle,
    onClose,
    modalType: "error",
    closeValue,
    widthType,
  };
  store.dispatch(openGlobalModal(modalValue));
};

export const showSuccessAlert = (title = "", subtitle = "", onClose = () => { }, widthType = null) => {
  const modalValue = {
    title,
    subtitle,
    onClose,
    modalType: "success",
    widthType
  };
  store.dispatch(openGlobalModal(modalValue));
};

export const handleBusinessLoginSession = async (loginSession = null) => {
  await businessInternalLogin(loginSession);
  const businessProfile = await getBusinessProfile();
  // await businessInternalSetProfile(businessProfile.data);
  window.location.replace(link.mobile.businessDetail);
  return true;
};

export const handleRegisterSession = async (registerPayload) => {
  await businessInternalLogin(registerPayload.authorization);
  await getBusinessProfile();
  // await businessInternalSetProfile(businessProfile.data);
  return true;
};

export const handleRegisterBusinessSession = async (registerPayload) => {
  await businessInternalLogin(registerPayload);
  // await businessInternalSetProfile(businessProfile.data);
  return true;
};


export const updateProfileBusiness = async () => {
  const businessProfile = await getBusinessProfile();
  // await businessInternalSetProfile(businessProfile.data);
  return true;
};

export const makeid = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
